<div class="excel-download" [ngClass]="{ 'excel-ar-download': current_lang === 'ar' }">
    <!--- Dropdown option -->
<!--- Dropdown option -->
  <div class="table-dropdown">
    <button class="btn-select-dropdown" [ngClass]="{'select-dropdown-proptype': dropDownOption?.showSelectedValue}" [matMenuTriggerFor]="menu" [disabled]="LockReport">
      <ng-container>
       <ng-container>{{ "reports.show_value_in" | translate }} :</ng-container>
        <span>{{
          selectedRadio
          ? ("reports." + selectedRadio | translate)
          : ("reports." + dropDownOption?.default | translate)
          }}</span>
      </ng-container>    
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu" [xPosition]="current_lang === 'ar' ? 'after' : 'before'" class="table-dropdown-menu">
      <div (click)="$event.stopPropagation()">
        <h5>
          {{ 'reports.show_price_in' | translate }}
        </h5>
        <mat-radio-group *ngIf="!dropDownOption?.reportType" aria-label="Select an option">
          <ng-container *ngFor="let option of dropDownOption?.data; let i = index">
            <mat-radio-button (change)="selectRadioValue(option.id, option.value)" value="{{ option.id }}"
              [checked]="option.id === dropDownOption?.default">{{ "reports." + option.value | translate
              }}</mat-radio-button>
          </ng-container>
        </mat-radio-group>

      </div>
    </mat-menu>
  </div>
    <!--- Down load icon -->
    <div class="download-excel-outer" *ngIf="
      tableData?.length !== 0 &&
      tableData &&
      allowExcelDownload
    ">
        <button class="download_excel" [disabled]="LockReport" *ngIf="!downloadLoading" (click)="downloadExcel()"
            matTooltip="{{ 'reports.download_excel' | translate }}" matTooltipPosition="above"><img *ngIf="!LockReport"
                src="../../../../../../assets/images/excel-icon.svg" />
            <img *ngIf="LockReport" src="../../../../../../assets/images/excel-icon-disable.svg" /></button>
        <span *ngIf="downloadLoading"><mat-spinner class="download-spinner"></mat-spinner></span>
    </div>
    <!--- Dropdown option -->
</div>

<div class="main-table">
    <table class="table" matSort>
        <thead>
            <tr>
                <ng-container *ngFor="let tableColumn of tableColumns">
                    <!-- <th> without mat-sort-header -->
                  <th [class.custom-bg-th]="tableColumn.border">
                             <span class="header_label">
                                    {{ tableColumn?.columnName | translate }}
                                    <span class="text-transform-normal">{{ tableColumn?.symbol | reportDataValueType }}</span>
                             </span>
                        </th>

                </ng-container>
            </tr>

        </thead>
        <tbody>
            <tr *ngFor="let element of tableData; let i = index"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                (click)="setExpadndColor(i)" [@detailExpand]="element.isOpen === 1 ? 'collapsed' : 'expanded'"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                [ngClass]="(expandedElement === element && !element['outlier'] ? 'example-expanded-row':'')"
                [ngClass]="{ hideTable: !showLoader }"
                [ngClass]="{'tr-parent': element.isParent, 'tr-child': !element.isParent}"
                [class.expand-hide]="element.isOpen === 1" [ngClass]="{'blur-content': element['NODATA']}">

                <td>
                    <div class="column-data align-items-center position-relative">
                        <!-- Expand Icon -->
                        <div class="expand-icon" [class.d-none]="!element.isDetail">
                            <mat-icon (click)="isChildOpen(element, i);
                            expandedElement =
                              expandedElement === element ? null : element
                          ">{{
                                expandedElement === element
                                ? "arrow_drop_down"
                                : current_lang === "ar"
                                ? "arrow_left"
                                : "arrow_right"
                                }}</mat-icon>
                        </div>
                        <div class="tooltip showonmap-column">
                            <!-- Column Name Text -->
                            <span class="column_entry" [attr.title]="element?.unit_size">
                                {{element?.unit_size}}
                            </span>
                        </div>
                    </div>
                </td>
                <ng-container *ngIf="selectedRadio == 'Range'">
                    <td><span matTooltip="{{(element['avg_grade_a+'] | number: '1.0-1')}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['avg_grade_a+'] ? false: true"> {{element['grade_a+_range'] ?? '-'}}</span></td> 
                    <td><span matTooltip="{{(element['avg_grade_a'] | number: '1.0-1')}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['avg_grade_a'] ? false: true"> {{element['grade_a_range'] ?? '-'}}</span></td>
                    <td><span matTooltip="{{(element['avg_grade_b'] | number: '1.0-1')}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['avg_grade_b'] ? false: true"> {{element['grade_b_range']  ?? '-'}}</span></td>
                    <td><span matTooltip="{{(element['avg_grade_c'] | number: '1.0-1')}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['avg_grade_c'] ? false: true"> {{element['grade_c_range']  ?? '-'}}</span></td>
                    <td><span matTooltip="{{(element['avg_grade_undefined'] | number: '1.0-1')}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['avg_grade_undefined'] ? false: true"> {{element['grade_undefined_range']  ?? '-'}}</span></td>
                </ng-container>
                 <ng-container *ngIf="selectedRadio == 'Average'">
                    <td><span matTooltip="{{element['grade_a+_range']}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['grade_a+_range'] ? false: true">{{(element['avg_grade_a+'] | number: '1.0-1') ?? '-'}}</span></td>
                    <td><span matTooltip="{{element['grade_a_range']}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['grade_a_range'] ? false: true">{{(element['avg_grade_a'] | number: '1.0-1') ?? '-'}}</span></td>
                    <td><span matTooltip="{{element['grade_b_range']}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['grade_b_range'] ? false: true">{{(element['avg_grade_b'] | number: '1.0-1')  ?? '-'}}</span></td>
                    <td><span matTooltip="{{element['grade_c_range']}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['grade_c_range'] ? false: true">{{(element['avg_grade_c'] | number: '1.0-1')  ?? '-'}}</span></td>
                    <td><span matTooltip="{{element['grade_undefined_range']}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element['grade_undefined_range'] ? false: true">{{(element['avg_grade_undefined'] | number: '1.0-1')  ?? '-'}}</span></td>
                </ng-container>
               
            </tr>
            <tr *ngIf="!showLoader" style="height: auto;" class="loader-tr">
                <td style="padding: 0;" [attr.colspan]="tableColumns?.length">
                    <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
                </td>
            </tr>
        </tbody>
    </table>
    <!--- No Record Found -->
    <div class="data_unavail" *ngIf="(tableData?.length === 0 || !tableData) && showLoader">
        <span>
            {{"reports.dataComingSoon" | translate}}
        </span>
    </div>
    <!-- Table content blur start -->
    <div class="lock-table-row" *ngIf="LockReport">
        <img src="../../../../../../assets/images/Lock.png" alt="">
    </div>
</div>
<!--- Pagination -->

<!--- data cleaned Text -->
<div class="dataCleaned">
    <span>
        <ng-container *ngIf="showEstaterText">{{
            "reports.dataCleaned" | translate
            }}</ng-container>
    </span>

</div>